export default __webpack_public_path__ + "static/media/onemin_logo.ca05a074.png";